(function () {
  var STORAGE_KEY = 'bvv_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  function refreshButton(btn) {
    var id = btn.dataset.productId;
    var isSaved = getWishlist().indexOf(id) !== -1;
    btn.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
  }

  document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
    refreshButton(btn);

    btn.addEventListener('click', function () {
      var id = btn.dataset.productId;
      var list = getWishlist();
      var index = list.indexOf(id);

      if (index === -1) {
        list.push(id);
      } else {
        list.splice(index, 1);
      }

      saveWishlist(list);
      refreshButton(btn);
    });
  });
})();